import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { isDisplayNameVisible, isNameReadOnly } from '../../../base/config/functions.any';
import { isScreenShareParticipantById } from '../../../base/participants/functions';
import VideoMenuTriggerButton from "./VideoMenuTriggerButton";
import IISightStatusIndicators from "../../../../11sight/features/filmstrip/components/IISightStatusIndicators";
const useStyles = makeStyles()(() => {
    return {
        videoContainer: {
            display: "flex",
            justifyContent: "flex-end",
            left: "4px",
            position: "absolute"
        }
    };
});
const ThumbnailBottomIndicators = ({ className, local, participantId, showStatusIndicators = true, thumbnailType, hidePopover, isHovered, popoverVisible, showPopover }) => {
    const { classes: styles, cx } = useStyles();
    const _allowEditing = !useSelector(isNameReadOnly);
    const _defaultLocalDisplayName = interfaceConfig.DEFAULT_LOCAL_DISPLAY_NAME;
    const _showDisplayName = useSelector(isDisplayNameVisible);
    const isVirtualScreenshareParticipant = useSelector((state) => isScreenShareParticipantById(state, participantId));
    return ((React.createElement("div", { className: cx(className, "bottom-indicators") },
        React.createElement("div", { className: styles.videoContainer },
            React.createElement(VideoMenuTriggerButton, { hidePopover: hidePopover, local: local, participantId: participantId, popoverVisible: popoverVisible, showPopover: showPopover, thumbnailType: thumbnailType, visible: isHovered })),
        showStatusIndicators && React.createElement(IISightStatusIndicators, { audio: !isVirtualScreenshareParticipant, moderator: true, participantID: participantId, screenshare: isVirtualScreenshareParticipant, thumbnailType: thumbnailType }))));
};
export default ThumbnailBottomIndicators;
